import {cailiaosum} from '@/api/cailiaodan.js'
import XLSX from 'xlsx'
import {add,cheng} from '@/utils/math.js'
import {getList as getpaylist} from "@/api/paylog.js"

export const  excelheader ={
	"材料类型":"type",
	"单价":"price",
	"数量":"num",
	"总计":"sum",
}

const excelfn = {
	filehandle(file){
		let {name,uid} = file
		const reader = new FileReader();
		reader.readAsBinaryString(file);
		reader.onload = (evt) => {
			try{
				const bstr = evt.target.result;
				const wb = XLSX.read(bstr, {type:'binary'});
				const wsname = wb.SheetNames[0];
				const ws = wb.Sheets[wsname];
				let data = XLSX.utils.sheet_to_json(ws,{
					header:"A",
				}),sumarr = []
				data = data.slice(1)
				data = data.map(item=>{
					let {A,B,C} = item,
					sum = cheng([B,C])
					sumarr.push(sum)
					return {type:A,price:B,num:C,sum}
				})
				this.formData.excels = [...this.formData.excels,{name,uid,data,sum:add(sumarr)}]
			}catch(e){
				console.log(e)
			}
		}
		return true
	},
	delexcel(uid){
		this.formData.excels = this.formData.excels.filter(item=>item.uid != uid)
	},
	exportall(){
	 let epts = document.getElementsByClassName("export-btn")
	 epts.forEach(item=>{
		 item.click()
	 })
	}
}

export const formdatafn ={
	...excelfn,
	getyuzhi(text,idcard){
		return cailiaosum({wpname:text,idcard}).then(ret=>{
			if(ret.code == 0){
				let {data:{clyuzhi}} = ret
				this.formData = {...this.formData,clyuzhi}
			}
			return this.formData
		})
	  },
	  getfromcailiaodan(val,e){
		  let {data:{attrs:{text}}} = e,{idcard,starttime,endtime} = this.formData
		  if(typeof starttime != "string"){
			starttime = starttime.format("YYYY-MM")
		  }
		  if(typeof endtime != "string"){
			endtime = endtime.format("YYYY-MM")
		  }
		  this.getyuzhi(text,idcard).then((formdata)=>{
			  getpaylist({idcard,time1:starttime,time2:endtime,workplace:val}).then(ret=>{
				  if(ret.code == 0){
					let {data:{money}} = ret
					this.formData = {...this.formData,fafang:money}
				  }
			  })
		  })
	  },
	  getyingfu(){
		  let {clinfo,excels} = this.formData,yingfu =0
		  if(clinfo){
			  yingfu = add(
				clinfo.map(item=>{
					return cheng([item.price,item.num])
				})
			  )
		  }
		  if(excels){
			  yingfu = add([yingfu,...excels.map(item=>item.sum)])
		  }
		  this.formData = {...this.formData,yingfu}
	  },
	  changejieyu(val){
		  let {yingfu,clyuzhi,fafang} = this.formData
			if(val == 1){
				this.formData = {...this.formData,jieyu:0}
			}else{
				this.formData = {...this.formData,jieyu:(yingfu-clyuzhi-fafang).toFixed(2)}
			}
		  return this.formData
	  },
}